import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'telefone'
})
export class TelefonePipe implements PipeTransform {
    transform(value: string): string {

        if (value) {
            // tslint:disable-next-line: triple-equals
            if (value.length === 10) {
                return `${value.substr(2, 4)}  ${value.substr(6, 4)}`
                // tslint:disable-next-line: triple-equals
            } if (value.length === 11) {
                return `${value.substr(2, 5)}  ${value.substr(7, 4)}`
            } else {
                return value;
            }
        } else {
            return value;
        }
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/telefone.pipe.ts